import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';

type BreadcrumbItem = {
    label: string;
    onClick?: () => void;
    href?: string;
};

const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: BreadcrumbItem[] }) => {
    return (
        <MuiBreadcrumbs className='mp-mask'>
            {breadcrumbs.slice(0, -1).map((crumb, index) => {
                return (
                    <Link
                        key={`breadcrumb-${crumb.label}-${index}`}
                        component={crumb.onClick || crumb.href ? 'button' : 'span'}
                        onClick={crumb.onClick}
                        href={crumb.href}
                        sx={{ cursor: crumb.onClick || crumb.href ? 'pointer' : 'default' }}
                    >
                        {crumb.label}
                    </Link>
                );
            })}
            <Typography variant='subtitle1' color='primary' fontWeight={'bold'}>
                {breadcrumbs[breadcrumbs.length - 1]?.label}
            </Typography>
        </MuiBreadcrumbs>
    );
};

export default Breadcrumbs;
